import { Button } from '@mui/material';
import { AlertCircleIcon } from 'resources/icons';
import PageNotFoundImg from '../../resources/undraw-not-found.svg';
import './index.css';
import { useNavigate } from 'react-router-dom';
import { EXECUTIONS } from 'navigator/links';

export default function NotFound404(): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className='not-found-404_root'>
      <div className='not-found-404_title'>
        <div className='not-found-404_alert-icon-container'>
          <AlertCircleIcon />
        </div>
        Page not found
      </div>
      <img className='not-found-404_img' src={PageNotFoundImg} alt='404' />
      <div className='not-found-404_actions'>
        <Button className='not-found-404_link' variant='contained' color='primary' onClick={() => navigate(EXECUTIONS)}>
          Home
        </Button>
      </div>
    </div>
  );
}
